import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

// Actions & service & constants
import { loadAppointmentsByPractId, clearList, cancelAppointments } from '../reducer/actions';
import { localAppointmentsFilters } from '../../services/appointments';
import { getAppointmentViewState } from 'src/services/functions';
import { STATUS_REPLACED, STATUS_CANCELLED } from 'src/services/constants';

// Components
import CustomModal from 'components/CustomModal';
import MultiSelectHeader from '../components/MultiSelectHeader';
import MultiSelectTable from '../components/MultiSelectTable/MultiSelectTable';

// Styles
import * as modalStyles from 'components/CustomModal/styles';
import { ActionBtn } from '../styles';

const storeDateKey = 'planingDate';

function filterFromStatus(appointments) {
  if (appointments && Array.isArray(appointments)) {
    return appointments.filter((appointment) => {
      const appointStatus = getAppointmentViewState(appointment);
      return appointStatus !== STATUS_CANCELLED && appointStatus !== STATUS_REPLACED;
    });
  }
  return null;
}


class CancelingView extends Component {
  constructor() {
    super();
    this.state = {
      startDate: moment(localAppointmentsFilters.get(storeDateKey)) || moment(),
      filterList: null,
      isOpenModal: false,
      selectedList: null,
      resetSelectListTimeStamp: null,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.loadAppointments = this.loadAppointments.bind(this);
    this.onTriggerModal = this.onTriggerModal.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onCancelAppointments = this.onCancelAppointments.bind(this);
  }

  componentDidMount() {
    this.loadAppointments();
  }

  componentDidUpdate(prevProps) {
    const { practitionerId } = this.props;
    const { appointments: { list } } = this.props;
    // if change practitioner
    if (prevProps.practitionerId !== practitionerId) { this.loadAppointments(); }
    // if list changed
    if (prevProps && JSON.stringify(prevProps.appointments.list) !== JSON.stringify(list)) {
      this.filteringAppointmentList();
    }
  }

  componentWillUnmount() {
    this.props.clearList();
  }

  onDateChange(date) {
    localAppointmentsFilters.set({ [storeDateKey]: moment(date).format() });
    this.setState({ startDate: date }, () => {
      this.loadAppointments();
    });
  }


  onTriggerModal() {
    const { isOpenModal } = this.state;
    this.setState({ isOpenModal: !isOpenModal });
  }

  onSelectionChanged(list) {
    this.setState({ selectedList: list });
  }

  onCancelAppointments() {
    const { selectedList } = this.state;
    const { cancelAppointments } = this.props;
    cancelAppointments(selectedList)
      .then(() => {
        this.onTriggerModal();
        this.setState({ resetSelectListTimeStamp: new Date().getTime() });
      })
      .catch(() => { this.onTriggerModal(); });
  }

  filteringAppointmentList() {
    const { appointments: { list } } = this.props;
    this.setState({ filterList: filterFromStatus(list) });
  }

  loadAppointments() {
    const { loadAppointmentsByPractId, practitionerId } = this.props;
    const { startDate } = this.state;
    if (practitionerId) { loadAppointmentsByPractId(practitionerId, startDate); }
  }

  render() {
    const { startDate, filterList, isOpenModal, selectedList, resetSelectListTimeStamp } = this.state;
    const { t, backUrl } = this.props;

    return (
      <Fragment>
        <MultiSelectHeader
          startDate={startDate}
          captionKey="canceling_page_caption"
          onDateChange={this.onDateChange}
          button={(
            <ActionBtn
              redType
              className="practitioner-logout-btn"
              onClick={this.onTriggerModal}
              disabled={!selectedList || selectedList.length === 0}
            >
              {t('cancel')}
            </ActionBtn>
          )}
        />

        <MultiSelectTable
          appointmentsList={filterList}
          backUrl={backUrl}
          onSelectionChanged={this.onSelectionChanged}
          resetTimeStamp={resetSelectListTimeStamp}
        />

        {/* ──── Confirm modal ───────────────────────────────────────────────────────────── */}
        <CustomModal
          isOpen={isOpenModal}
          onRequestClose={this.onTriggerModal}
          style={{ content: { maxWidth: '33em', padding: 0 } }}
        >
          <modalStyles.CommonModalWrapper>
            {/* ──── Header ──────────────────────────────────────────────────────────────── */}
            <modalStyles.ModalBlockSection className="header-wrapper">
              <modalStyles.ModalCloseIcon className="close-icon" onClick={this.onTriggerModal} />
              <modalStyles.ModalTitle>{t('canceling_page_modal_caption')}</modalStyles.ModalTitle>
            </modalStyles.ModalBlockSection>

            {/* ──── Content ────────────────────────────────────────────────────────────────── */}
            <modalStyles.ModalBlockSection borderBottom className="optional">
              <span>{t('canceling_page_confirm_text')}</span>
            </modalStyles.ModalBlockSection>

            {/* ──── Footer ───────────────────────────────────────────────────────────────── */}

            <modalStyles.ModalFooter className="footer">
              <modalStyles.ModalFooterCancelBtn onClick={this.onTriggerModal}>
                {t('popup_cancel_button')}
              </modalStyles.ModalFooterCancelBtn>

              <modalStyles.ModalFooterBtn onClick={this.onCancelAppointments}>
                {t('confirm')}
              </modalStyles.ModalFooterBtn>
            </modalStyles.ModalFooter>

          </modalStyles.CommonModalWrapper>
        </CustomModal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  appointments: state.practitioner.appointments,
  practitionerId: state.practitioner.common.commonFilters.practitionerId,
  backUrl: state.practitioner.common.backUrl,
});

export default connect(
  mapStateToProps,
  {
    clearList,
    loadAppointmentsByPractId,
    cancelAppointments,
  },
)(translate()(CancelingView));
